/**
 * Role check helpers.
 *
 * Roles the UI checks:
 *   - 'admin'         — DZ ops human, cross-tenant, manually provisioned in Keycloak.
 *   - 'platform_user' — Tenant user via self-serve signup.
 *
 * See backend spec
 * docs/superpowers/specs/2026-06-16-email-nurture-delivery-and-platform-role-design.md §2.
 */
import type { User } from '@/lib/types';

export type Role = 'admin' | 'platform_user';

export const hasRole = (user: User | null | undefined, role: Role): boolean =>
  Boolean(user?.roles?.includes(role));

export const isAdmin = (user: User | null | undefined): boolean => hasRole(user, 'admin');

export const isPlatformUser = (user: User | null | undefined): boolean =>
  hasRole(user, 'platform_user');
